// import React, { useEffect, useState } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { getUserSettingsSelector } from '../../../../common/redux/userSettings/userSettingsSlice';
import AnalysesGroupsView from '../AnalysesGroupsView/AnalysesGroupsView';
import './AnalysesGroupsContainer.scss';

const AnalysesContainer = ({ isCustomPage, isKFAsPage, isNonePage }) => {
  const routeParams = useParams();
  const { projectId } = routeParams;
  const userSettings = useSelector(getUserSettingsSelector);

  const location = useLocation();
  const history = useHistory();

  // it replaces old analyses route to new one without influence on other analyses routes
  if (location.pathname.endsWith('analyses')) {
    history.push(
      location.pathname.replace('analyses', 'analyses-groups/custom')
    );
  }

  /* eslint-disable prefer-const */
  // Disable prefer const because of possible
  // feature flag overwrite of viewGrid.
  const {
    settings: { viewGrid },
  } = userSettings;

  return (
    <AnalysesGroupsView
      projectId={projectId}
      viewGrid={viewGrid}
      isCustomPage={isCustomPage}
      isKFAsPage={isKFAsPage}
      isNonePage={isNonePage}
    />
  );
};

export default AnalysesContainer;
